import { render, staticRenderFns } from "./ChecklistDetails.vue?vue&type=template&id=4161fbd4&"
import script from "./ChecklistDetails.vue?vue&type=script&lang=js&"
export * from "./ChecklistDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports